<template>
  <BookingErrorModal :name="name">
    <template #action>
      <FreeButton
        type="button"
        class="gray-button w-full"
        @click="emit('onConfirm')"
      >
        {{ $t('contacts.warnings.allClear') }}
      </FreeButton>
    </template>
  </BookingErrorModal>
</template>

<script setup lang="ts">
  import { FreeButton } from 'freedom-shared';

  import { BookingErrorModal } from '@/entities/booking-error-modal';

  defineProps<{
    name: string;
  }>();

  const emit = defineEmits<{
    (e: 'onConfirm'): void;
  }>();
</script>
